/* eslint-disable @typescript-eslint/naming-convention */
export enum Permissions {
    SuperUser = 'superuser',
    Manager = 'manager',
    Accounting = 'accounting',
    StoreOwner = 'store-owner',
    Purchaser = 'purchaser',
    WareHouse = 'warehouse',
    AuditInventoryCounts = 'audit-inventory-counts',
    AuditReceivingRecords = 'audit-receiving-records',
    ReceiveShipments = 'receive-shipments',
    ApprovePayments = 'approve-payments',
    CountInventory = 'count-inventory',
    Hr = 'hr',
}
